import { useEffect, useState } from 'react';

const MITI_SLOT_LABELS = [
  'GI',
  'Persuade',
  'Persuade_with',
  'Q',
  'SR',
  'CR',
  'AF',
  'S',
  'Seek',
  'Emphasize',
  'Confront',
  'NC',
];

function useMitiSlotMachine(active, intervalMs = 80) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active) {
      setIndex(0);
      return undefined;
    }

    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % MITI_SLOT_LABELS.length);
    }, intervalMs);
    return () => window.clearInterval(timer);
  }, [active, intervalMs]);

  return MITI_SLOT_LABELS[index];
}

export default useMitiSlotMachine;
